/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Person = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.2501 14C10.1788 14 8.30485 14.8386 6.94679 16.1967C5.58946 17.554 4.75024 19.1772 4.75012 21.25L19.7462 21.2573C19.6819 19.2382 18.821 17.4225 17.4663 16.111C16.1158 14.8035 14.2775 14 12.2501 14ZM5.88613 15.136C7.51399 13.5082 9.76502 12.5 12.2501 12.5C14.6824 12.5 16.8906 13.4659 18.5097 15.0333C20.3181 16.7842 21.3948 19.2894 21.2344 22.0391L21.1938 22.734L3.21848 22.7333L3.15624 22.0391C2.90443 19.2305 4.07816 16.944 5.88613 15.136Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.2501 2.5C10.3171 2.5 8.75009 4.067 8.75009 6C8.75009 7.933 10.3171 9.5 12.2501 9.5C14.1831 9.5 15.7501 7.933 15.7501 6C15.7501 4.067 14.1831 2.5 12.2501 2.5ZM7.25009 6C7.25009 3.23858 9.48867 1 12.2501 1C15.0115 1 17.2501 3.23858 17.2501 6C17.2501 8.76142 15.0115 11 12.2501 11C9.48867 11 7.25009 8.76142 7.25009 6Z"
                        fill={color}
                    />
                </svg>
        );
    };
